import React, { useState, useEffect } from 'react';

// लोकल इमेजेस इंपोर्ट्स
import img1 from '../image/images (1).jpg';
import img2 from '../image/i7.jpg';
import img3 from '../image/i8.webp';
import img4 from '../image/i10.webp';
import img5 from '../image/images (2).jpg';
import img6 from '../image/images (3).jpg';
import img7 from '../image/images (4).jpg';
import img8 from '../image/images (7).jpg';

// तिरंगा रंगांनुसार आयकॉन्स
const IconPerson = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF671F" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="7" r="4" />
    <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
  </svg>
);

const IconBriefcase = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000080" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="8" width="18" height="12" rx="2" />
    <path d="M8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);

const IconCap = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#138808" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 9l10-5 10 5-10 5-10-5z" />
    <path d="M6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
  </svg>
);

const IconCamera = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FF671F" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 8h3l2-2h6l2 2h3v11H4z" />
    <circle cx="12" cy="13" r="3.2" />
  </svg>
);

export default function Gallery() {
  const [showModal, setShowModal] = useState(false);

  const photos = [img1, img2, img3, img4, img5, img6, img7, img8];

  // स्क्रोल ऑब्झर्व्हर कार्ड्स ॲनिमेट करण्यासाठी
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    const cards = document.querySelectorAll('.fade-slide-card');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="gallery" style={{ backgroundColor: '#d2fcdb' }} className="py-4 py-lg-5 overflow-hidden">
      <style>{`
        /* Fade Slide Down Animation Base */
        .fade-slide-card {
          opacity: 0;
          transform: translateY(-40px);
          transition: opacity 0.7s cubic-bezier(0.25, 1, 0.5, 1),
                      transform 0.7s cubic-bezier(0.25, 1, 0.5, 1);
          will-change: opacity, transform;
        }

        .fade-slide-card.is-visible {
          opacity: 1;
          transform: translateY(0);
        }

        /* Staggered Delay */
        .delay-1 { transition-delay: 0.1s; }
        .delay-2 { transition-delay: 0.25s; }
        .delay-3 { transition-delay: 0.4s; }
        .delay-4 { transition-delay: 0.55s; }

        .info-card-anim {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .info-card-anim:hover {
          transform: translateY(-6px) !important;
          box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12) !important;
        }

        .gallery-grid-4 {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 6px;
          margin-bottom: 16px;
        }

        .gallery-btn-hover {
          transition: all 0.3s ease;
        }
        .gallery-btn-hover:hover {
          background-color: #e05310 !important;
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(255, 103, 31, 0.35);
        }

        .modal-overlay {
          position: fixed;
          inset: 0;
          background-color: rgba(0, 0, 0, 0.75);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          backdrop-filter: blur(4px);
        }

        .modal-content-custom {
          background-color: #ffffff;
          border-radius: 16px;
          padding: 24px;
          max-width: 800px;
          width: 90%;
          max-height: 85vh;
          overflow-y: auto;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
        }

        .modal-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
          gap: 12px;
          margin-top: 16px;
        }
      `}</style>

      <div className="container-fluid">
        <div className="row g-3 g-lg-4">
          
          {/* Card 1: COACH */}
          <div className="col-12 col-sm-6 col-lg-3 fade-slide-card delay-1">
            <div className="info-card-anim h-100" style={styles.card}>
              <div style={styles.cardHeader}>
                <div style={{ ...styles.iconBadge, backgroundColor: '#fff3e0' }}><IconPerson /></div>
                <h6 style={styles.boxTitle}>COACH</h6>
              </div>
              <div style={styles.coachRow}>
                <img
                  src="https://images.unsplash.com/photo-1633332755192-727a05c4013d?auto=format&fit=crop&w=300&q=80"
                  alt="Ashok Kale"
                  style={styles.coachImg}
                />
                <div style={styles.coachTextCol}>
                  <p style={styles.coachName}>Mr. Ashok Kale</p>
                  <p style={styles.coachSub}>Asian Gold Medalist in Triple Jump</p>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2: WORK EXPERIENCE */}
          <div className="col-12 col-sm-6 col-lg-3 fade-slide-card delay-2">
            <div className="info-card-anim h-100" style={styles.card}>
              <div style={styles.cardHeader}>
                <div style={{ ...styles.iconBadge, backgroundColor: '#e8eaf6' }}><IconBriefcase /></div>
                <h6 style={styles.boxTitle}>WORK EXPERIENCE</h6>
              </div>

              <p style={styles.expRole}>Director</p>
              <p style={styles.expDetail}>Nature Fitness Solutions Private Limited, Pune</p>
              <p style={styles.expDate}>2013 Jun - Present</p>
              <p style={styles.expDetail}>Manufacturing of Open Gym Equipment</p>

              <p style={{ ...styles.expRole, marginTop: '12px' }}>Coach</p>
              <p style={styles.expDetail}>MUSH University, Pune</p>
              <p style={styles.expDate}>1998 Aug - 2014 Nov</p>
              <p style={styles.expDetail}>Coach of Athletics &amp; Volleyball</p>
            </div>
          </div>

          {/* Card 3: EDUCATION */}
          <div className="col-12 col-sm-6 col-lg-3 fade-slide-card delay-3">
            <div className="info-card-anim h-100" style={{ ...styles.card, position: 'relative' }}>
              <div style={styles.cardHeader}>
                <div style={{ ...styles.iconBadge, backgroundColor: '#e8f5e9' }}><IconCap /></div>
                <h6 style={styles.boxTitle}>EDUCATION</h6>
              </div>
              <p style={styles.expRole}>BSC</p>
              <p style={styles.expDetail}>ACS College Akurdi Pune</p>
              <p style={styles.expDate}>1997 - 2000</p>
              <p style={styles.expDetail}>Pune</p>
              <p style={styles.expDetail}>Graduate in Chemistry</p>
              <span style={styles.diplomaIcon} role="img" aria-label="diploma">🎓</span>
            </div>
          </div>

          {/* Card 4: GALLERY */}
          <div className="col-12 col-sm-6 col-lg-3 fade-slide-card delay-4">
            <div className="info-card-anim h-100" style={styles.card}>
              <div style={styles.cardHeader}>
                <div style={{ ...styles.iconBadge, backgroundColor: '#fff3e0' }}><IconCamera /></div>
                <h6 style={styles.boxTitle}>GALLERY</h6>
              </div>
              
              <div className="gallery-grid-4">
                {photos.slice(0, 4).map((img, i) => (
                  <img key={i} src={img} alt={`Gallery ${i + 1}`} style={styles.galleryImg} />
                ))}
              </div>

              <button 
                className="gallery-btn-hover" 
                style={styles.galleryBtn} 
                onClick={() => setShowModal(true)}
              >
                VIEW FULL GALLERY →
              </button>
            </div>
          </div>

        </div>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content-custom" onClick={(e) => e.stopPropagation()}>
            <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
              <h5 style={{ color: '#000080', fontWeight: '800', margin: 0 }}>PHOTO GALLERY</h5>
              <button 
                onClick={() => setShowModal(false)}
                style={styles.closeBtn}
              >
                ✕
              </button>
            </div>
            
            <div className="modal-grid">
              {photos.map((img, i) => (
                <img key={i} src={img} alt={`Full Gallery ${i + 1}`} style={styles.modalImg} />
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

const styles = {
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    padding: '20px 18px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.07)',
    border: '1px solid rgba(226, 232, 240, 0.8)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '14px',
    paddingBottom: '10px',
    borderBottom: '1px solid #f1f5f9',
  },
  iconBadge: {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // React मध्ये CamelCase आवश्यक आहे
    flexShrink: 0,
  },
  boxTitle: {
    fontWeight: '700',
    color: '#000080',
    fontSize: '15px',
    letterSpacing: '0.3px',
    margin: 0,
  },
  coachRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  coachImg: {
    width: '72px',
    height: '72px',
    objectFit: 'cover',
    borderRadius: '10px',
    border: '2px solid #FF671F',
    flexShrink: 0,
  },
  coachTextCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center', // React मध्ये CamelCase आवश्यक आहे
  },
  coachName: { fontSize: '15px', fontWeight: '700', color: '#000080', margin: '0 0 3px' },
  coachSub: { fontSize: '14px', color: '#138808', margin: 0, lineHeight: '1.4', fontWeight: '500' },
  expRole: { fontSize: '15px', fontWeight: '700', color: '#000080', margin: 0 },
  expDetail: { fontSize: '14px', color: '#138808', margin: '3px 0', lineHeight: '1.5', fontWeight: '500' },
  expDate: { fontSize: '14px', color: '#FF671F', fontWeight: '700', margin: '3px 0' },
  diplomaIcon: {
    position: 'absolute',
    bottom: '16px',
    right: '16px',
    fontSize: '24px',
    opacity: 0.9,
  },
  galleryBtn: {
    backgroundColor: '#FF671F',
    color: '#fff',
    border: 'none',
    fontSize: '11px',
    fontWeight: '800',
    padding: '10px 14px',
    borderRadius: '6px',
    width: '100%',
    cursor: 'pointer',
  },
  galleryImg: {
    width: '100%',
    height: '55px',
    objectFit: 'cover',
    borderRadius: '6px',
  },
  modalImg: {
    width: '100%',
    height: '130px',
    objectFit: 'cover',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
  },
  closeBtn: {
    border: 'none',
    background: 'transparent',
    fontSize: '20px',
    cursor: 'pointer',
    color: '#FF671F',
    fontWeight: 'bold',
  }
};
